import {
  CustomInputProps,
  CheckboxGroupProps,
  CategoryFields,
} from 'src/components/MultistepForm/shared/types';
import { removeFromStorage } from 'src/utils/helpers';
import { storageKeys } from 'src/components/MultistepForm/shared/constants';

export const getCustomInputData = (
  type: string,
  title: string,
  description: string
): CustomInputProps => {
  return {
    type,
    title,
    description,
  };
};

export const getCheckboxGroupData = (
  { wpProductCategory: parentCategory },
  customInputData?: CustomInputProps
): CheckboxGroupProps => {
  // 1. Create object and fill with initial values
  const checkboxGroup: CheckboxGroupProps = {
    name: parentCategory.slug,
    options: [],
    customInput: customInputData,
  };

  // 2. Destructure passed graphql data
  const {
    wpChildren: { nodes: childCategories },
  } = parentCategory;

  // 3. Map child categories data to the object
  childCategories.map((category, index) => {
    checkboxGroup.options[index] = {
      value: category.name,
      title: category.name,
      description: category.description,
      image: category.image,
    };
  });

  return checkboxGroup;
};

export const isAllFieldsFilled = (fields: CategoryFields): boolean => {
  return !Object.values(fields).some(field =>
    typeof field === 'number' ? field === 0 : field.length === 0
  );
};

export const clearFormDataFromStorage = (): void => {
  removeFromStorage(storageKeys.FORM_VALUES);
  removeFromStorage(storageKeys.CURRENT_STEP);
};
